import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosInstance from "../../Component/axiosInstance";

export const addcity = createAsyncThunk('addcity',async(data,{rejectWithValue})=>{
    try {
        const response = await axiosInstance.post('/citydetail/addcitydetail',data,{
            headers:{
                'Content-Type': 'application/json',
                'x-projection-id': 'id',
                
            }
        })
        return response.data;
    } catch (error) {
          return rejectWithValue(error.response?.data?.message || "An unexpected error occurred")
    }
});


const addcityslice = createSlice({name:'addcity',
    initialState:{
        loading:false,
        error:null,
        data:null,
        isSuccess:false,
        isError:false,
    },
    reducers:{},
    extraReducers:(builder)=>{
        builder.addCase(addcity.pending,(state)=>{
            state.loading = true;
                state.error = null;
                state.data = null;
                state.isSuccess = false;
                state.isError = false;
        })
        .addCase(addcity.rejected,(state,action)=>{
               state.loading = false;
                state.error = action.payload || action.error.message;
                state.data = null;
                state.isError = true;  // Fixed issue here
                state.isSuccess = false;
        })
        .addCase(addcity.fulfilled,(state,action)=>{
             state.loading = false;
                state.data = action.payload.data;
                state.isSuccess = true;
                state.isError = false;
        })
    }
});

export default addcityslice.reducer;